import { Modal, Select } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useEffect } from 'react'
import { StatusEnum } from 'src/enums/StatusEnum'
import { DateInput, DatesProvider, DateValue } from '@mantine/dates'
import { useForm } from '@mantine/form'
import api from 'src/utils/Api'
import CustomButtom from '../customButtom'
import { IconArrowBarLeft, IconPrinter } from '@tabler/icons-react'
import { MESSAGE_ERROR_SERVIDOR } from 'src/utils/Constants'
import { ErrorNotification } from '../notification/errorNotification'
import { openByteArrayNewTab } from 'src/utils/Files'

type IProps = {
  route: string
  openModal: boolean
  listStatus?: StatusEnum[]
  closeModal: (value: boolean) => void
}

const ModalRelatorio: React.FC<IProps> = ({
  route,
  openModal,
  closeModal,
  listStatus,
}) => {
  useEffect(() => {
    if (openModal) {
      open()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal])
  const handleChange = (
    event: string | number | boolean | DateValue | File,
    key: string
  ) => {
    form.setFieldValue(key, event)
  }
  const exit = () => {
    close()
    form.reset
    closeModal(false)
  }
  const form = useForm<{
    status: StatusEnum | null
    dataInicio?: Date | null
    dataFim?: Date | null
  }>({
    initialValues: {
      status: null,
      dataInicio: null,
      dataFim: null,
    },
  })

  const printContas = async () => {
    await api
      .post(route, form.values, {
        responseType: 'blob',
      })
      .then(r => {
        openByteArrayNewTab(r.data, 'file')
        form.reset()
        exit()
      })
      .catch(() => {
        ErrorNotification({ message: MESSAGE_ERROR_SERVIDOR })
      })
  }
  const [opened, { open, close }] = useDisclosure(false)
  return (
    <Modal
      opened={opened}
      onClose={close}
      size={'md'}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      trapFocus={false}
      centered
      radius={10}
    >
      {listStatus && (
        <Select
          {...form.getInputProps('status')}
          onChange={v => handleChange(v!, 'status')}
          withinPortal
          clearable
          size="xs"
          zIndex={10000000}
          label="Status"
          placeholder="Selecione um status"
          nothingFound="Nothing found"
          searchable
          data={listStatus}
        />
      )}
      <DatesProvider
        settings={{
          locale: 'pt-br',
        }}
      >
        <DateInput
          {...form.getInputProps('dataInicio')}
          onChange={val => handleChange(val, 'dataInicio')}
          locale="pt-BR"
          valueFormat="DD MMMM, YYYY"
          required
          size="xs"
          label={'Data de início'}
        />
        <DateInput
          {...form.getInputProps('dataFim')}
          onChange={val => handleChange(val, 'dataFim')}
          locale="pt-BR"
          valueFormat="DD MMMM, YYYY"
          required
          size="xs"
          label={'Data termíno'}
        />
      </DatesProvider>
      <CustomButtom
        customJustify="space-between"
        customButtons={[
          {
            label: 'Voltar',
            color: 'red',
            onClick: () => exit(),
            icon: <IconArrowBarLeft />,
            type: 'button',
          },
          {
            label: 'Baixar',
            onClick: () => printContas(),
            icon: <IconPrinter />,
            type: 'button',
          },
        ]}
      />
    </Modal>
  )
}
export default ModalRelatorio
